export default {
    login: {
        first: 'Tvoříme',
        second: 'řešení pro každého',
        third: 'Náš jednoduchý a inteligentní design vám poskytne nástroje k přeměně dat v reálném čase na okamžité výsledky ve výkonu firmy.',
        desc: 'Přihlaste se za pomoci informací uvedených níže',
        username: 'Užívatelské jméno',
        password: 'Heslo',
        successful: 'Přihlášení úspěšné',
        logout: 'Odhlášení',
        log: 'Přihlášení',
        in: '',
    },
    dashboard: {
        title: 'Zařízení',
        search: 'Hledej',
        nav: {
            type: 'Typ',
            location: 'Poloha',
            batch: 'Kalibrace',
            remark: 'Poznámka',
            lqi: 'Spojení',
            lqi_hover: 'Indikátor kvality připojení',
            unit: 'Zařízení',
            frame_update: 'Nastavení odesláno',
            l_update: 'Poslední data',
            timing: 'Dynamické časování',
            sensing: 'Dynamické snímání',
            notification: 'Notifikacie',
            favourite: 'Oblíbené',
        },
        bulk_setup: {
            substrate_properties: 'Vlastnosti substrátu',
            frame_selection: 'Výběr rámce',
            critical_value: 'Prahové hodnoty pro notifikace',
            payload_error: 'Formát rámece měření vybraných zařízení není totožný',
            batch_type_error: 'Typ šarže zařízení není identický (vlastnosti deaktivovány)',
            batch_missing_error: 'Jedno nebo více zařízení nemá nastaveno šarži (vlastnosti deaktivovány)',
            batch_all_error: 'Chcete-li pokračovat, nastavte všechny vlastnosti',
        },
        remark: {
            double_click: 'Dvojitým kliknutím',
            to_add: 'přidáte hodnotu',
        },
    },
    map: {
        calculated: 'Vypočítané umístění',
        manual: 'Ruční umístění',
    },
    detail: {
        new_calib_point: 'Přidat nový kalibrační bod',
        remove_calib_point: 'Odebrat kalibrační bod',
        raw_value: 'Hrubá hodnota',
        calibrate_min: 'Kalibrovat min.',
        calibrate_max: 'Kalibrovat max.',
        apply_calib: 'Použít kalibraci na vlastnosti',
        reset_minmax: 'Resetujte minimální a maximální hodnoty',
        reset_calib: 'Obnovte kalibraci šarže',
        select_props: 'Vyberte vlastnosti pro které chcete kalibrovat',
        save_props: 'Uložit do vybraných vlastností',
        percent: 'VWC',
        batch: 'Šarže',
        selected_batch: 'Vybraná Šarže',
        raw: 'Raw',
        warning: 'Pozor',
        warning_vwc: 'Hodnota pro VWC nebo ekvivalent RAW je neplatná. Opravte hodnoty tak, aby byly větší než minimální, menší než maximální nebo jakákoli jiná neexistující hodnota.',
        measured_min: 'Měřené minimum',
        measured_max: 'Měřené maximum',
        select_props: 'Vyberete vlastnosti',
        lqi: 'Kvalita spojení',
        lqi_calculated: 'Vypočítáno pomocí stanic.',
        map: 'Umístění senzora',
        sensor_setting: 'Nastavení senzora',
        etentacles_setting: 'Nastavení iTentacles',
        min_value: 'Minimální hodnota',
        last_value: 'Poslední hodnota',
        max_value: 'Maximální hodnota',
        select_data: 'Výběr dat',
        missing: 'Nejsou dostupné data',
        moisture_calibration: 'Kalibrace VWC',
        warning_batch_calibration: 'Pozor! Kalibrujete šarži',
        warning_device_calibration2: 'Pozor! Chcete-li použít kalibraci na vlastnosti - klikněte na "Použít kalibraci na vlastnosti"',
        device_only_label: 'Kalibrace pouze pro zařízení',
        payload_format: 'Rámec měření (zařízení)',
        payload_format_change: 'Změňte rámec měření',
        payload_format_not_set: 'Zatím neaktualizováno',
        payload_format_changed: 'Poslední změna',
        payload_format_updated: 'Naposledy aktualizováno',
        format: 'Rámec',
        set_format: 'Nastavit rámec',

        dynamic_sensing: 'Dynamické snímání',
        measurement_frame: 'Rámec měření',
        none: 'Žádný',
        moisture: 'Vlhkost',
        temperature: 'Teplota',
        light: 'Světlo',
        measurement_sets: 'Akumulované sady měření',
        measurement_interval: 'Interval měření',
        downlik_period: 'Downlinkové období',
        downlink_retries: 'Opakování downlinku',
        transmitting_power: 'Vysílací výkon',
        message_interval: 'Interval zprávy',
        device_lifespan: 'Životnost zařízení',
        once_per_four: 'Jednou za 4 dny',
        once_per_two: 'Jednou za 2 dny',
        once_per_day: 'Jednou denně',
        twice_per_day: 'Dvakrát denně',
        set_dynamic_sensing: 'Nastavit dynamické snímání'
    },
    lqi: {
        Excellent: 'Vynikající',
        Good: 'Dobrý',
        Average: 'Dostatečný',
        Limit: 'Omezený'
    },
    server_status: {
        title: 'Status servera',
    },
    privacy: {
        title: 'Zásady ochrany osobních údajů',
    },
    sigfox_coverage: {
        title: 'Pokrytí Sigfox',
        coverage_error: 'Výpadek služby Pokrytí Sigfox',
        unstable: 'Neexistuje žádné pokrytí a zařízení se nemusí synchronizovat.',
        works_underground: 'Spojení je silné a zařízení by mělo fungovat v podzemí nebo hluboko v interiéru.',
        possible_underground: 'Spojení je dostatečně silné, aby umožňovalo práci v podzemí nebo hluboko v interiéru.',
        works_indoor: 'Spojení je stabilní a zařízení by mělo fungovat v interiéru (nemusí fungovat pod zemí).',
        possible_indoor: 'Spojení je dostatečně stabilní, aby zařízení mohlo pracovat v interiéru. (nemusí fungovat pod zemí).',
        works_open: 'Spojení nemusí být stabilné ale zařízení by mělo fungovat na otevřeném poli.',
        possible_open: 'Zařízení získá spojení a existuje možnost, že by zařízení mělo fungovat na otevřeném poli.',
    },
    payload: {
        title: 'Soil 3XS zatížení',
    },
    export: {
        limit: 'Vyberte posledních x hodnot z vybraných zařízení Tentacle',
        info: {
            first: 'Exportovat',
            second: 'vybraných Tentacle',
            rest: 'Nejprve vyberte některé Tentacle z tabulky',
        },
        tabs: {
            date_range: 'Časové období',
            limit_values: 'Limitní hodnoty',
        },
    },
    contact_us: {
        title: 'Kontaktujte nás',
        subj: 'Předmět',
        mess: 'Vzkaz',
    },
    tooltips: {
        customer: 'Zobrazovací zařízení přiřazená tomuto zákazníkovi.',
        logout: 'Odhlášení',
        total_units: 'Počet zařízení',
        unit_name: 'Název Tentaclu',
        excel: 'Export do souboru Excel',
        csv: 'Export ve formátu CSV',
        search: 'nebo stiskněte',
        tentacle_missing: 'vyberte alespoň jeden',
    },
    buttons: {
        ok: 'Ok',
        login: 'Přihlášení',
        detail: 'Detail',
        apply: 'Použít změny',
        apply_range: 'Aplikovat rozsah',
        bulk: 'Hromadné nastavení',
        bulkdetail: 'Hromadný detail',
        cancel: 'Zrušit',
        send: 'Odeslat',
        export: 'Exportovat',
        delete_range: 'Smazat rozsah',
        next: 'Další',
        previous: 'Předchozí',
        save: 'Uložit',
    },
    metrics: {
        moisture: 'VWC',
        light: 'Světlo',
        temperature: 'Teplota',
        battery: 'Baterie',
        pressure: 'Tlak',
        pump_mode: 'Čerpadlo běží',
        gyroscope: 'Vibrace',
        events: 'Události',
        currents: 'Fázový proud',
        angles: 'Fázový úhel',
        over_vibration_stop: 'Zastavení proti vibracím',
    },
    timing: {
        t1: '15 minut',
        t2: '30 minut',
        t3: '1 hodina',
        t4: '2 hodiny',
        t5: '8 hodin',
        t6: 'Vypnout',
    },
    interval: {
        day: 'den',
        week: 'za týden',
        month: 'za měsíc',
        year: 'za rok',
    },
    notifications: {
        push: 'Notifikace',
    },
    sensing: {
        sens1: 'Aktuální Soil 3XT-4',
        sens2: 'Originalí 2x za hodinu',
        sens3: 'Vlhkost 4x za Hodinu',
        sens4: 'Vlhkost 3x za 45 min',
        sens5: 'Vlhost/Teplota 2x za 30 min',
        sens6: 'Vlkost/Teplota/Světlo 2x za 30 min',
    },
    info: {
        loading_data: 'Načítám data'
    },
};
